import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SearchLocalModule } from '../../pipes/search-local/search-local.module';

@Component({
	selector: 'hk-vl-checklist',
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, SearchLocalModule],
	templateUrl: './vl-checklist.component.html',
	styleUrls: ['./vl-checklist.component.scss'],
})
export class VlChecklistComponent {
	@Input() value: Array<string | number> = [];
	@Input() options: Array<{
		label: string | number;
		value: string | number;
		disabled?: boolean;
		item?: any;
	}> = [];
	@Input() customMsgNotOptions: string | undefined;
	@Input() isMulti: boolean = false;
	search = new FormControl('');

	@Input() colorCheck: string = '#eff1fd';
	@Output() onChange: EventEmitter<any> = new EventEmitter();

	subs: Subscription[] = [];

	ngOnInit(): void {
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['value']) {
			if (!Array.isArray(this.value)) {
				this.value = [];
			}
		}
	}

	ngOnDestroy(): void {
		//Called once, before the instance is destroyed.
		//Add 'implements OnDestroy' to the class.
		this.subs.forEach((sub) => sub.unsubscribe());
	}

	toggleOptions(option: { label: string | number; value: string | number; disabled?: boolean; item?: any }) {
		if (this.isMulti) {
			this.value.includes(option.value) ? this.value.splice(this.value.indexOf(option.value), 1) : this.value.push(option.value);
		} else {
			this.value = [option.value];
		}
		this.onChange.emit(this.value);
	}
}
